import React from "react";

export default function RCFormattedDescription({ description }) {
  if (!description || description === "nan" || description.trim() === "") {
    return null;
  }

  // const cleanedDescription = description
  //   .replace(/ΓÇÖ/g, "'")
  //   .replace(/┬á/g, " ")
  //   .trim();

  const cleanedDescription = description
    .replace(/<[^>]*>/g, "")
    .replace(/ΓÇÖ/g, "'")
    .replace(/ΓÇ»/g, " ")
    .replace(/ΓÇ£/g, '"')
    .replace(/ΓÇ¥/g, '"')
    .replace(/┬á/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  // Fix missing space after period before capital letter
  const normalizedText = cleanedDescription.replace(/\.([A-Z])/g, ". $1");

  const rawParagraphs = normalizedText.split(/\\|\n/);

  // =====================================================
  // CASE 3 → Structured "Title: Content" Format
  // =====================================================

  const colonMatches = normalizedText.match(/[A-Z][A-Za-z0-9\s,&'\-]+:/g);

  if (colonMatches && colonMatches.length >= 2) {
    const sections = [];
    const titleRegex = /([A-Z][A-Za-z0-9\s,&'\-]+:)/g;

    const splitParts = normalizedText.split(titleRegex);

    const introText = splitParts[0].trim();

    if (introText) {
      sections.push({ type: "intro", content: introText });
    }

    for (let i = 1; i < splitParts.length; i += 2) {
      const title = splitParts[i].replace(":", "").trim();
      const content = splitParts[i + 1]?.trim() || "";

      sections.push({ type: "feature", title, content });
    }

    return (
      <div className="productDescription">
        {sections.map((section, index) => {
          if (section.type === "intro") {
            return (
              <p key={index} className="mt-3">
                {section.content}
              </p>
            );
          }

          return (
            <p key={index} className="mt-3">
              <strong>{section.title}:</strong> {section.content}
            </p>
          );
        })}
      </div>
    );
  }
  // =====================================================
  // CASE 4 → Capitalized Heading Sentence Format (FIXED)
  // =====================================================

  // Fix missing space after period
  const normalizedTextCase4 = cleanedDescription.replace(/\.([A-Z])/g, ". $1");

  const sentencesCase4 = normalizedTextCase4.split(/(?<=\.)\s+/);

  const isHeadingSentence = (sentence) => {
    const trimmed = sentence.trim();

    if (!trimmed.endsWith(".")) return false;

    const textWithoutDot = trimmed.slice(0, -1);

    const words = textWithoutDot.split(" ");

    // Short sentence
    if (words.length > 8) return false;

    // Must start uppercase
    if (textWithoutDot[0] !== textWithoutDot[0].toUpperCase()) return false;

    // Avoid long descriptive sentences
    if (textWithoutDot.includes(",")) return false;

    return true;
  };

  let sectionsCase4 = [];
  let currentSection = null;

  sentencesCase4.forEach((sentence) => {
    if (isHeadingSentence(sentence)) {
      if (currentSection) {
        sectionsCase4.push(currentSection);
      }

      currentSection = {
        title: sentence.slice(0, -1).trim(),
        content: ""
      };
    } else if (currentSection) {
      currentSection.content += " " + sentence.trim();
    } else {
      sectionsCase4.push({
        title: null,
        content: sentence.trim()
      });
    }
  });

  if (currentSection) {
    sectionsCase4.push(currentSection);
  }

  const headingCountCase4 = sectionsCase4.filter(s => s.title).length;

  if (headingCountCase4 >= 2) {
    return (
      <div className="productDescription">
        {sectionsCase4.map((section, index) => (
          <div key={index} className="mt-3">
            {section.title && (
              <p>
                <strong>{section.title}.</strong>
              </p>
            )}
            {section.content && (
              <p>{section.content.trim()}</p>
            )}
          </div>
        ))}
      </div>
    );
  }

  // =====================================================
  // CASE 1 → First Sentence Bold Format
  // =====================================================

  const isHeadingStyle = (text) => {
    const firstDotIndex = text.indexOf(".");
    if (firstDotIndex === -1) return false;

    const firstPart = text.substring(0, firstDotIndex).trim();
    const words = firstPart.split(" ");

    return words.every(
      (word) =>
        word.length > 0 &&
        word[0] === word[0].toUpperCase()
    );
  };

  const firstValidParagraph = rawParagraphs.find(p => p.trim() !== "");
  const useBoldFormat = firstValidParagraph
    ? isHeadingStyle(firstValidParagraph.trim())
    : false;

  if (useBoldFormat) {
    return (
      <div className="productDescription">
        {rawParagraphs.map((paragraph, index) => {
          const trimmed = paragraph.trim();
          if (!trimmed) return null;

          const firstDotIndex = trimmed.indexOf(".");

          if (firstDotIndex !== -1) {
            const boldText = trimmed.substring(0, firstDotIndex + 1);
            const remainingText = trimmed.substring(firstDotIndex + 1);

            return (
              <p key={index} className="mt-2">
                <strong>{boldText}</strong>
                {remainingText}
              </p>
            );
          }

          return (
            <p key={index} className="mt-2">
              {trimmed}
            </p>
          );
        })}
      </div>
    );
  }

  // =====================================================
  // CASE 2 → Default 3-Sentence Paragraph Format
  // =====================================================

  const sentencesDefault = normalizedText.split(/(?<=\.)\s+/);
  const paragraphs = [];
  let tempParagraph = [];

  sentencesDefault.forEach((sentence, index) => {
    tempParagraph.push(sentence);

    if (tempParagraph.length === 3 || index === sentencesDefault.length - 1) {
      paragraphs.push(tempParagraph.join(" "));
      tempParagraph = [];
    }
  });

  return (
    <div className="productDescription">
      {paragraphs.map((para, index) => (
        <p key={index} className="mt-3">
          {para}
        </p>
      ))}
    </div>
  );
}


// import React from "react";

// export default function RCFormattedDescription({ description }) {
//   if (!description || description === "nan" || description.trim() === "") {
//     return null;
//   }

//   const cleanedDescription = description
//     .replace(/ΓÇÖ/g, "'")
//     .replace(/┬á/g, " ")
//     .trim();

//   // Split by \ or new line first
//   const rawParagraphs = cleanedDescription.split(/\\|\n/);

//   // Function to check if all words before first dot start with capital
//   const isHeadingStyle = (text) => {
//     const firstDotIndex = text.indexOf(".");
//     if (firstDotIndex === -1) return false;

//     const firstPart = text.substring(0, firstDotIndex).trim();
//     const words = firstPart.split(" ");

//     return words.every(
//       (word) =>
//         word.length > 0 &&
//         word[0] === word[0].toUpperCase()
//     );
//   };

//   // Check first meaningful paragraph
//   const firstValidParagraph = rawParagraphs.find(p => p.trim() !== "");
//   const useBoldFormat = firstValidParagraph
//     ? isHeadingStyle(firstValidParagraph.trim())
//     : false;

//   // =========================
//   // CASE 1 → Heading Style Format
//   // =========================
//   if (useBoldFormat) {
//     return (
//       <div className="productDescription">
//         {rawParagraphs.map((paragraph, index) => {
//           const trimmed = paragraph.trim();
//           if (!trimmed) return null;

//           const firstDotIndex = trimmed.indexOf(".");

//           if (firstDotIndex !== -1) {
//             const boldText = trimmed.substring(0, firstDotIndex + 1);
//             const remainingText = trimmed.substring(firstDotIndex + 1);

//             return (
//               <p key={index} className="mt-2">
//                 <strong>{boldText}</strong>
//                 {remainingText}
//               </p>
//             );
//           }

//           return (
//             <p key={index} className="mt-2">
//               {trimmed}
//             </p>
//           );
//         })}
//       </div>
//     );
//   }

//   // =========================
//   // CASE 2 → Normal 3-Sentence Paragraph Format
//   // =========================
//   const sentences = cleanedDescription.split(/(?<=\.)\s+/);
//   const paragraphs = [];
//   let tempParagraph = [];

//   sentences.forEach((sentence, index) => {
//     tempParagraph.push(sentence);

//     if (tempParagraph.length === 3 || index === sentences.length - 1) {
//       paragraphs.push(tempParagraph.join(" "));
//       tempParagraph = [];
//     }
//   });

//   return (
//     <div className="productDescription">
//       {paragraphs.map((para, index) => (
//         <p key={index} className="mt-3">
//           {para}
//         </p>
//       ))}
//     </div>
//   );
// }